import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import EditCampaignScreen from "../screens/EditCampaignScreen";
import CampaignListScreen from "../screens/CampaignListScreen";
import CampaignScreen from "../screens/CampaignScreen";
import NewCampaignScreen from "../screens/NewCampaignScreen";

type CampaignsRouterProps = RouteComponentProps;

const CampaignsRouter: React.FC<CampaignsRouterProps> = ({
  match,
}) => (
  <Switch>
    <Route
      path={`${match.path}/new`}
      exact
      component={NewCampaignScreen}
    />
    <Route
      path={`${match.path}/:id`}
      exact
      component={CampaignScreen}
    />
    <Route
      path={`${match.path}/:id/edit`}
      exact
      component={EditCampaignScreen}
    />
    <Route
      path={`${match.path}`}
      exact
      component={CampaignListScreen}
    />
  </Switch>
);

export default CampaignsRouter;
